import DetailSubtitle from './DetailSubtitle'

export default DetailSubtitle
// eslint-disable-next-line import/export
export * from './DetailSubtitle'
